import {gql} from "@apollo/client";
import {client} from "api";
import {DocumentType} from "interfaces";

interface QueryParams {
  sencenet: string;
  documentType: DocumentType;
}

interface QueryResult {
  validateCourseDocs: boolean;
}

export const VALIDATE_COURSE_DOCS_QUERY = gql`
  query ValidateCourseDocs($sencenet: String!, $documentType: DocumentType!) {
    validateCourseDocs(sencenet: $sencenet, type: $documentType)
  }
`;

export const validateCourseDocs = async (
  {
    sencenet,
    documentType,
  }: {
    sencenet: string,
    documentType: DocumentType,
  }): Promise<boolean> => {
  const {data} = await client.query<QueryResult, QueryParams>({
    query: VALIDATE_COURSE_DOCS_QUERY,
    variables: {sencenet, documentType},
    fetchPolicy: "network-only",
  });
  return !!data?.validateCourseDocs;
};
